import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ExcuseInsertRequest } from "./ExcuseInsertRequest";
import { StringRequest } from "../../class-attendance-excuse-setup/shared/StringRequest";
import { ExcuseUpdateRequest } from "./ExcuseUpdateRequest";

@Injectable()
export class DataService_ExcuseSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadExcuse(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadExcuse?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseInsert(parms: ExcuseInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ExcuseInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseCodeInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ExcuseCodeInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseDescInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ExcuseDescInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseUpdate(parms: ExcuseUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ExcuseUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseDelete(ExcuseID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ExcuseDelete?ExcuseID=" + ExcuseID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseToggle(ExcuseID, Active) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ExcuseToggle?ExcuseID=" + ExcuseID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
